/**
 * CMCD request header name.
 *
 *
 * @beta
 */
export const CMCD_REQUEST = 'CMCD-Request'
